import { RefreshTokenService, AbpHttpConfigurationService } from 'abp-ng2-module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import * as ApiServiceProxies from './service-proxies';
import { ZeroRefreshTokenService } from '@account/auth/zero-refresh-token.service';
import { SironaHttpInterceptor } from '@shared/common/http/sironaHttpInterceptor';
import { ZeroTemplateHttpConfigurationService } from './zero-template-http-configuration.service';

@NgModule({
    providers: [
        ApiServiceProxies.AuditLogServiceProxy,
        ApiServiceProxies.CachingServiceProxy,
        ApiServiceProxies.ChatServiceProxy,
        ApiServiceProxies.CommonLookupServiceProxy,
        ApiServiceProxies.EditionServiceProxy,
        ApiServiceProxies.FriendshipServiceProxy,
        ApiServiceProxies.HostSettingsServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.LanguageServiceProxy,
        ApiServiceProxies.NotificationServiceProxy,
        ApiServiceProxies.OrganizationUnitServiceProxy,
        ApiServiceProxies.MailDistributionServiceProxy,
        ApiServiceProxies.PermissionServiceProxy,
        ApiServiceProxies.ProfileServiceProxy,
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.TenantSettingsServiceProxy,
        ApiServiceProxies.TimingServiceProxy,
        ApiServiceProxies.CodeServiceProxy,
        ApiServiceProxies.ConfigServiceProxy,
        ApiServiceProxies.MedRegServiceProxy,
        ApiServiceProxies.NaregServiceProxy,
        ApiServiceProxies.PsyRegServiceProxy,
        ApiServiceProxies.AddressAutocompleteServiceProxy,
        ApiServiceProxies.PeopleApplicationServiceProxy,
        ApiServiceProxies.SponsorshipApplicationServiceProxy,
        ApiServiceProxies.LiaTypeServiceProxy,
        ApiServiceProxies.LiaPersonServiceProxy,
        ApiServiceProxies.LiaContactServiceProxy,
        ApiServiceProxies.LiaRestrictionsServiceProxy,
        ApiServiceProxies.LiaInvoiceAddressServiceProxy,
        ApiServiceProxies.LiaDocumentServiceProxy,
        ApiServiceProxies.LiaLanguageSkillServiceProxy,
        ApiServiceProxies.LiaAcademicTitleServiceProxy,
        ApiServiceProxies.LiaEmploymentsServiceProxy,
        ApiServiceProxies.LiaEmploymentUpdateServiceProxy,
        ApiServiceProxies.LiaProfessionalResponsibilityServiceProxy,
        ApiServiceProxies.LiaVaccinationServiceProxy,
        ApiServiceProxies.LiaSelfEmploymentServiceProxy,
        ApiServiceProxies.LiaEhcLanguageSkillServiceProxy,
        ApiServiceProxies.LiaElectronicPatientRecordServiceProxy,
        ApiServiceProxies.LiaPracticeServiceProxy,
        ApiServiceProxies.LiaQualityRequirementServiceProxy,
        ApiServiceProxies.LiaEmploymentOrPostgraduateTitleServiceProxy,
        ApiServiceProxies.EhcServiceProxy,
        ApiServiceProxies.EhcSelfEmploymentServiceProxy,
        ApiServiceProxies.EhcMedicalFieldServiceProxy,
        ApiServiceProxies.EhcLanguageSkillServiceProxy,
        ApiServiceProxies.EhcPracticeServiceProxy,
        ApiServiceProxies.EhcPracticeConfigurationServiceProxy,
        ApiServiceProxies.EhcElectronicPatientRecordServiceProxy,
        ApiServiceProxies.EhcStaffServiceProxy,
        ApiServiceProxies.EhcPostgraduateTitleServiceProxy,
        ApiServiceProxies.EhcDocumentServiceProxy,
        ApiServiceProxies.EhcContactServiceProxy,
        ApiServiceProxies.EhcInvoiceAddressServiceProxy,
        ApiServiceProxies.EhcRegisterServiceProxy,
        ApiServiceProxies.EhcQualityRequirementServiceProxy,
        ApiServiceProxies.EhcEmploymentOrPostgraduateTitleServiceProxy,
        ApiServiceProxies.ApplicationServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.UserLinkServiceProxy,
        ApiServiceProxies.UserLoginServiceProxy,
        ApiServiceProxies.WebLogServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.SponsorshipServiceProxy,
        ApiServiceProxies.CorporateLicenceServiceProxy,
        ApiServiceProxies.CorporateLicenceRestrictionServiceProxy,
        ApiServiceProxies.ClaServiceProxy,
        ApiServiceProxies.ClaDocumentServiceProxy,
        ApiServiceProxies.ClaSponsorshipServiceProxy,
        ApiServiceProxies.ClaAuthorizationServiceProxy,
        ApiServiceProxies.ClaBusinessServiceProxy,
        ApiServiceProxies.ClaBusinessSelectServiceProxy,
        ApiServiceProxies.ClaMedicalFieldDirectorServiceProxy,
        ApiServiceProxies.ClaMedicalFieldDirectorRepresentativeServiceProxy,
        ApiServiceProxies.ClaRangeOfServicesServiceProxy,
        ApiServiceProxies.ClaInfrastructureServiceProxy,
        ApiServiceProxies.ClaMedicalFieldPersonServiceProxy,
        ApiServiceProxies.ClaMedicalFieldPersonAlasServiceProxy,
        ApiServiceProxies.ClaPersonAlasServiceProxy,
        ApiServiceProxies.ClaAcademicTitleAlasServiceProxy,
        ApiServiceProxies.ClaContactAlasServiceProxy,
        ApiServiceProxies.ClaDiplomaAlasServiceProxy,
        ApiServiceProxies.ClaLanguageSkillAlasServiceProxy,
        ApiServiceProxies.ClaBusinessAlasServiceProxy,
        ApiServiceProxies.ClaEmploymentAlasServiceProxy,
        ApiServiceProxies.ClaRestrictionsAlasServiceProxy,
        ApiServiceProxies.ClaDocumentAlasServiceProxy,
        ApiServiceProxies.ClaCurrentAssistantsAlasServiceProxy,
        ApiServiceProxies.ClaTrainerServiceProxy,
        ApiServiceProxies.ClaAssistantPhysicianServiceProxy,
        ApiServiceProxies.ClaPersonelServiceProxy,
        ApiServiceProxies.ClaServiceAreasServiceProxy,
        ApiServiceProxies.ClaTreatmentServiceProxy,
        ApiServiceProxies.ClaNursingBedsServiceProxy,
        ApiServiceProxies.ClaFloorsServiceProxy,
        ApiServiceProxies.ClaAidingResourcesServiceProxy,
        ApiServiceProxies.ClaSecurityServiceProxy,
        ApiServiceProxies.ClaDrugChambersServiceProxy,
        ApiServiceProxies.ClaSanitaryFacilitiesServiceProxy,
        ApiServiceProxies.ClaWheelchairAccessibilityServiceProxy,
        ApiServiceProxies.ClaQualityServiceProxy,
        ApiServiceProxies.ClaServiceAreasServiceProxy,
        ApiServiceProxies.ClaInvoiceAddressServiceProxy,
        ApiServiceProxies.ClaMedicalFieldResponsibleForStorageAndQualityServiceProxy,
        ApiServiceProxies.ClaMedicalFieldResponsibleForHaemovigilanceServiceProxy,
        ApiServiceProxies.ClaElectronicPatientRecordServiceProxy,
        ApiServiceProxies.ClaQualityRequirementServiceProxy,
        ApiServiceProxies.ClaSecurityAndInsuranceServiceProxy,
        ApiServiceProxies.ClaRestrictionsServiceProxy,
        ApiServiceProxies.SlasRangeOfProductsServiceProxy,
        ApiServiceProxies.SlasProductPreparationServiceProxy,
        ApiServiceProxies.SlasLocalDrugSalesServiceProxy,
        ApiServiceProxies.SlasDrugProductionServiceProxy,
        ApiServiceProxies.SlasDrugProductionThirdPartyServiceProxy,
        ApiServiceProxies.OlaOnlineDrugSalesServiceProxy,
        ApiServiceProxies.MutServiceProxy,
        ApiServiceProxies.MutPersonServiceProxy,
        ApiServiceProxies.MutApplicantContactServiceProxy,
        ApiServiceProxies.MutApplicantPersonServiceProxy,
        ApiServiceProxies.MutApplicantSponsorshipServiceProxy,
        ApiServiceProxies.MutApplicantBusinessServiceProxy,
        ApiServiceProxies.MutApplicantAdditionalCommentsServiceProxy,
        ApiServiceProxies.MutApplicantBusinessServiceProxy,
        ApiServiceProxies.MutApplicantSponsorshipServiceProxy,
        ApiServiceProxies.MutSponsorshipServiceProxy,
        ApiServiceProxies.MutSponsorshipDirectorServiceProxy,
        ApiServiceProxies.MutBusinessServiceProxy,
        ApiServiceProxies.MutEmploymentServiceProxy,
        ApiServiceProxies.MutMedicalFieldDirectorServiceProxy,
        ApiServiceProxies.MutMedicalFieldPersonServiceProxy,
        ApiServiceProxies.MutAdditionalAcademicTitleServiceProxy,
        ApiServiceProxies.MutDocumentServiceProxy,
        ApiServiceProxies.MutationApplicationServiceProxy,
        ApiServiceProxies.SlapServiceProxy,
        ApiServiceProxies.SlapDocumentServiceProxy,
        ApiServiceProxies.SlapPersonServiceProxy,
        ApiServiceProxies.SlapBusinessServiceProxy,
        ApiServiceProxies.SlapContactServiceProxy,
        ApiServiceProxies.SlapProductPreparationServiceProxy,
        ApiServiceProxies.SlapRangeOfProductsServiceProxy,
        ApiServiceProxies.SlapInvoiceAddressServiceProxy,
        ApiServiceProxies.SplServiceProxy,
        ApiServiceProxies.SplDocumentServiceProxy,
        ApiServiceProxies.SplPersonServiceProxy,
        ApiServiceProxies.SplNarcoticKnowledgeServiceProxy,
        ApiServiceProxies.SplPostgraduateTitleServiceProxy,
        ApiServiceProxies.AlapServiceProxy,
        ApiServiceProxies.AlaInvoiceAddressServiceProxy,
        ApiServiceProxies.AlaDocumentServiceProxy,
        ApiServiceProxies.AlaApplicantPersonServiceProxy,
        ApiServiceProxies.AlaApplicantSponsorshipServiceProxy,
        ApiServiceProxies.AlaApplicantContactServiceProxy,
        ApiServiceProxies.AlaPersonServiceProxy,
        ApiServiceProxies.AlaContactServiceProxy,
        ApiServiceProxies.AlaDiplomaServiceProxy,
        ApiServiceProxies.AlaBusinessServiceProxy,
        ApiServiceProxies.AlaEmploymentServiceProxy,
        ApiServiceProxies.AlaAcademicTitleServiceProxy,
        ApiServiceProxies.AlaMedicalFieldServiceProxy,
        ApiServiceProxies.AlaLanguageSkillServiceProxy,
        ApiServiceProxies.AlaRestrictionsServiceProxy,
        ApiServiceProxies.AlaPostgraduateTitleServiceProxy,
        ApiServiceProxies.AlaMedicalFieldDirectorServiceProxy,
        ApiServiceProxies.RequirementServiceProxy,
        ApiServiceProxies.ProfessionRegisterAffiliationServiceProxy,
        ApiServiceProxies.SponsorshipTypeRegisterAffiliationServiceProxy,
        ApiServiceProxies.RequirementGroupServiceProxy,
        ApiServiceProxies.EmploymentServiceProxy,
        ApiServiceProxies.PersonLicenceServiceProxy,
        ApiServiceProxies.TraineePersonLicenceServiceProxy,
        ApiServiceProxies.EmploymentAddressServiceProxy,
        ApiServiceProxies.ApplicationEmploymentPersonServiceProxy,
        ApiServiceProxies.RestrictionServiceProxy,
        ApiServiceProxies.ClaStatusWizardStepServiceProxy,
        ApiServiceProxies.LiaStatusWizardStepServiceProxy,
        ApiServiceProxies.EhcStatusWizardStepServiceProxy,
        ApiServiceProxies.AlapStatusWizardStepServiceProxy,
        ApiServiceProxies.SlapStatusWizardStepServiceProxy,
        ApiServiceProxies.EhcPracticeConfigurationServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.TenantRegistrationServiceProxy,
        ApiServiceProxies.HostDashboardServiceProxy,
        ApiServiceProxies.InvoiceServiceProxy,
        ApiServiceProxies.SubscriptionServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.UiCustomizationSettingsServiceProxy,
        ApiServiceProxies.DashboardServiceProxy,
        ApiServiceProxies.PersonDossierServiceProxy,
        ApiServiceProxies.FileDossierServiceProxy,
        ApiServiceProxies.DocumentManagementSystemServiceProxy,
        ApiServiceProxies.AddressServiceProxy,
        ApiServiceProxies.BusinessServiceProxy,
        ApiServiceProxies.DiplomaServiceProxy,
        ApiServiceProxies.PostgraduateTitleServiceProxy,
        ApiServiceProxies.AcademicTitleServiceProxy,
        ApiServiceProxies.UserDelegationServiceProxy,
        ApiServiceProxies.TwitterServiceProxy,
        ApiServiceProxies.PendencesServiceProxy,
        ApiServiceProxies.SapInvoiceServiceProxy,
        ApiServiceProxies.JobsServiceProxy,
        ApiServiceProxies.JobOutputFilesServiceProxy,
        ApiServiceProxies.SensitiveDataServiceProxy,
        ApiServiceProxies.SqlQueryServiceProxy,
        ApiServiceProxies.SqlQueryAdministrationServiceProxy,
        ApiServiceProxies.SqlQueryEnumServiceProxy,
        ApiServiceProxies.CriminalPenaltyServiceProxy,
        ApiServiceProxies.AdditionalInformationServiceProxy,
        ApiServiceProxies.DocumentManagementSystemTemplateAdministrationServiceProxy,
        ApiServiceProxies.DocumentManagementSystemTemplateServiceProxy,
        ApiServiceProxies.DocumentManagementSystemScanImportServiceProxy,
        ApiServiceProxies.UidRegisterServiceProxy,
        ApiServiceProxies.PostgraduateTitleProfessionServiceProxy,
        ApiServiceProxies.PostgraduateTitleProfessionServiceProxy,
        ApiServiceProxies.EhcCapServiceProxy,
        ApiServiceProxies.EhcCapWaitListServiceProxy,
        ApiServiceProxies.HealthRegCachingServiceProxy,
        ApiServiceProxies.MySironaLegitimationServiceProxy,
        ApiServiceProxies.DossierLegitimationServiceProxy,
        ApiServiceProxies.MySironaUserServiceProxy,
        ApiServiceProxies.MySironaPersonServiceProxy,
        ApiServiceProxies.MySironaSponsorshipServiceProxy,
        ApiServiceProxies.MySironaDocumentServiceProxy,
        ApiServiceProxies.HealthRegServiceProxy,
        ApiServiceProxies.MigrationServiceProxy,
        ApiServiceProxies.LegServiceProxy,
        ApiServiceProxies.CogsServiceProxy,
        ApiServiceProxies.NdnServiceProxy,
        ApiServiceProxies.LogbookServiceProxy,
        ApiServiceProxies.HealthRegisterSnapshotServiceProxy,
        ApiServiceProxies.NarcoticPrescriptionBlockServiceProxy,
        ApiServiceProxies.InspectionServiceProxy,
        ApiServiceProxies.InspectorServiceProxy,
        ApiServiceProxies.RlaServiceProxy,
        ApiServiceProxies.RlaInvoiceAddressServiceProxy,
        ApiServiceProxies.RlaDocumentServiceProxy,
        ApiServiceProxies.RlaApplicantPersonServiceProxy,
        ApiServiceProxies.RlaApplicantContactServiceProxy,
        ApiServiceProxies.RlaPersonServiceProxy,
        ApiServiceProxies.RlaContactServiceProxy,
        ApiServiceProxies.RlaBusinessServiceProxy,
        ApiServiceProxies.RlaReplacementServiceProxy,
        ApiServiceProxies.NpboServiceProxy,
        ApiServiceProxies.NpboRegisterServiceProxy,
        ApiServiceProxies.NpboAddressServiceProxy,
        ApiServiceProxies.NpboNumberServiceProxy,
        ApiServiceProxies.NpfServiceProxy,
        ApiServiceProxies.LoggedMailServiceProxy,
        ApiServiceProxies.MunicipalityServiceProxy,
        ApiServiceProxies.RegionServiceProxy,
        { provide: RefreshTokenService, useClass: ZeroRefreshTokenService },
        { provide: AbpHttpConfigurationService, useClass: ZeroTemplateHttpConfigurationService },
        { provide: HTTP_INTERCEPTORS, useClass: SironaHttpInterceptor, multi: true }
    ]
})
export class ServiceProxyModule { }
